export default "__VITE_ASSET__BddXf3y9__"